import { Routes } from "@angular/router";
import { DashboardComponent } from "./shared/layouts/dashboard/dashboard.component";
import { AuthGuard } from "./shared/services/guard.service";

export const APP_ROUTES: Routes = [
  { path: "", pathMatch: "full", redirectTo: "dp/claims" },
  {
    path: "authentication",
    loadChildren: () =>
      import("./modules/authentication/auth.routes").then((m) => m.AUTH_ROUTES),
  },
  {
    path: "dp",
    canActivate: [AuthGuard],
    component: DashboardComponent,
    children: [{ path: "", pathMatch: "full", redirectTo: "claims" },
      {
        path: "claims",
        loadChildren: () =>
          import("./modules/damage-protection/claims/claims.routes").then(
            (m) => m.CLAIMS_ROUTES
          ),
      }],
  },
  {
    path: "ew",
    canActivate: [AuthGuard],
    component: DashboardComponent,
    children: [
      { path: "", pathMatch: "full", redirectTo: "claims" },
      {
        path: "policies",
        loadChildren: () =>
          import("./modules/extended-warranty/policies/policies.routes").then(
            (r) => r.POLICIES_ROUTES,
          ),
      },
      {
        path: "claims",
        loadChildren: () =>
          import("./modules/extended-warranty/claims/claims.routes").then((r) => r.CLAIMS_ROUTES),
      },
      {
        path: "tbm-policies",
        loadChildren: () =>
          import("./modules/extended-warranty/tbm-policies/tbm-policies.routes").then(
            (r) => r.TBM_POLICIES_ROUTES,
          ),
      },
    ],
  },
];
